import {createFetchListActions} from 'common/actions/utils';
import Agency from 'common/types/Agency';
import AgencyInfo from 'common/types/AgencyInfo';
import UserApi from 'common/api/UserApi';
import AgencyApi from '../api/AgencyApi';

const ID_PROP = 'name';

export const REQUEST_USER_AGENCIES = 'REQUEST_USER_AGENCIES';
export const RECEIVE_USER_AGENCIES = 'RECEIVE_USER_AGENCIES';
export const {
  fetchUserAgencies,
  fetchUserAgenciesIfNeeded,
} = createFetchListActions({
  name: 'user agency',
  pluralName: 'user agencies',
  DataType: Agency,
  idProp: ID_PROP,
  keys: ['product'],
  api: new UserApi(),
});

export const {
  fetchAgencies,
} = createFetchListActions({
  name: 'agency',
  pluralName: 'agencies',
  DataType: Agency,
  idProp: ID_PROP,
  keys: ['product'],
  api: new AgencyApi(),
});

export const REQUEST_AGENCY_INFO = 'REQUEST_AGENCY_INFO';

export function requestAgencyInfo() {
  return {type: REQUEST_AGENCY_INFO};
}

export const RECEIVE_AGENCY_INFO = 'RECEIVE_AGENCY_INFO';

export function receiveAgencyInfo(json) {
  return {
    type: RECEIVE_AGENCY_INFO,
    info: json,
  };
}

export function fetchAgencyInfo(agencyId) {
  return (dispatch, getState, {agencyApi}) => {
    dispatch(requestAgencyInfo());
    return agencyApi.agency(agencyId)
      .then(response => response.json())
      .then(item => new AgencyInfo(item))
      .then(obj => dispatch(receiveAgencyInfo(obj)))
      ;
  };
}

function shouldFetchAgencyInfo(state, agencyId) {
  const agency = state.agency;
  if (!agency || !agency.info) {
    return true;
  } else if (agency.isFetchingInfo) {
    return false;
  }
  return agency.info.name !== agencyId;
}

export const _shouldFetchAgencyInfo = shouldFetchAgencyInfo; // For testing

export function fetchAgencyInfoIfNeeded(agencyId) {
  return (dispatch, getState) => {
    if (shouldFetchAgencyInfo(getState(), agencyId)) {
      return dispatch(fetchAgencyInfo(agencyId));
    }
    return Promise.resolve();
  };
}

export const CLEAR_AGENCY_INFO = 'CLEAR_AGENCY_INFO';

export function clearAgencyInfo() {
  return {type: CLEAR_AGENCY_INFO};
}



// WEBPACK FOOTER //
// ./src/common/actions/agency.js